import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Ahmed Ahres
          </h1>
          <h2 className="title-font text-2xl mb-4 font-medium text-white">Co-Founder @ Nativ</h2>
          <p className="mb-8 leading-relaxed">
            Grew up in Tunisia as a professional Tennis player and passionate about technology <br></br>
            Studied Computer Science both in the Netherlands and in Switzerland, currently living in London <br></br>
            Early Machine Learning Engineer at Revolut, Founding Engineer at Heron Data (YC S20) & Senior ML Engineer at XYZ Reality <br></br>
            Currently building something new <br></br>
          </p>
          <div className="flex justify-center">
            <a
              href="#projects"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              My projects
            </a>
            <a
              href="#contact"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              Contact
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            src="./ahmed_pic2.png"
          />
        </div>
      </div>
    </section>
  );
}


// WEBPACK FOOTER //
// ./src/components/About.js